/**
 * @param {import("../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/posts",
    },
    (router) => {
      router.push({
        id: "@api/post@search",
        path: "",
      });

      router.push({
        id: "@api/post@create",
        path: "",
      });

      router.group(
        {
          path: "/:postId",
        },
        (router) => {
          router.push({
            id: "@api/post@show",
            path: "",
          });

          router.push({
            id: "@api/post@update",
            path: "",
          });

          router.push({
            id: "@api/post@delete",
            path: "",
          });

          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                id: "@api/post@restore",
                path: "/restore",
              });
            },
          );
        },
      );

      router.group(
        {
          path: "/categories",
        },
        (router) => {
          router.push({
            id: "@api/postCategory@search",
            path: "",
          });
        },
      );
    },
  );
}
